import React from "react";
import { useFormContext } from "react-hook-form";
import { Button } from "@moneyforward/mfx_biz_react_components";
import {
  KanaNameFormField,
  NameFormField,
  PasswordFormField,
  UsernameFormField,
} from "@/components/molecules";
import { CancelListBackButton } from "@/components/atoms";
import {
  passwordValidation,
  usernameValidation,
} from "@/components/validations";
import { useIsSpMode } from "@/hooks";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";

export type RegisterUserFormBizsolValues = {
  username: string;
  password: string;
  firstName: string;
  firstNameKana: string;
  middleName: string;
  middleNameKana: string;
  lastName: string;
  lastNameKana: string;
};

type Props = {
  onSubmit: (formValues: RegisterUserFormBizsolValues) => void;
};

export const RegisterUserFormBizsol = (props: Props) => {
  const isSpMode = useIsSpMode();
  const { handleSubmit, formState } = useFormContext();

  return (
    <div css={container}>
      <div css={!isSpMode ? box : spModeBox}>
        <form
          onSubmit={handleSubmit(props.onSubmit)}
          css={form}
          autoComplete="off"
        >
          <div css={!isSpMode ? inputList : spModeInputList}>
            <div css={listItem}>
              <NameFormField
                nameLastName="lastName"
                nameFirstName="firstName"
              />
            </div>
            <div css={listItem}>
              <KanaNameFormField
                nameLastName="lastNameKana"
                nameFirstName="firstNameKana"
              />
            </div>
          </div>
          <div css={{ border: "1px solid #DADEDF", margin: "10px 0 20px 0" }} />
          <div css={listItem}>
            <UsernameFormField
              name="username"
              whetherToDisplayTheValidationRule={true}
              validate={usernameValidation}
              requiredLabel={true}
              hideHelpToolTip={true}
              labelText={
                "「tanaka.tarou-0001」のように氏名や従業員番号・会社名などを組み合わせられます"
              }
            />
          </div>
          <div css={listItem}>
            <PasswordFormField
              name="password"
              usePasswordMeter={true}
              registerOptions={{
                validate: passwordValidation,
              }}
              requiredLabel={true}
              isTemporary={true}
            />
          </div>
          <div css={buttonWrapper}>
            <CancelListBackButton />
            <Button
              type="submit"
              variant="primary"
              css={buttonMargin}
              disabled={formState.isSubmitting}
            >
              登録
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  minHeight: "245px",
  padding: "36px 32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const spModeBox = css({
  width: "640px",
  minHeight: "245px",
  padding: "15px 17px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const form = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputList = css({
  flex: 1,
});

const spModeInputList = css({
  flex: 1,
});

const listItem = css({
  marginBottom: "15px",
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: "8px",
});
const buttonMargin = css({
  marginLeft: "16px",
});
